import { Stack, styled } from '@mui/material';

import { forMobile, theme } from '@/shared/design-system';

export const VerificationContent = styled(Stack)({
  flexDirection: 'column',
  gap: `${theme.spacing[24]}px`,
});

export const InlineVerificationContent = styled(VerificationContent, {
  shouldForwardProp: (prop) => prop !== '$fillAvailableHeight',
})<{ $fillAvailableHeight: boolean }>(({ $fillAvailableHeight }) => ({
  ...($fillAvailableHeight && {
    flexGrow: 1,
    minHeight: 0,
  }),
}));

export const OtpBlock = styled(Stack)({
  alignItems: 'flex-start',
  flexDirection: 'column',
  gap: `${theme.spacing[12]}px`,
});

export const PendingStatus = styled(Stack)({
  alignItems: 'center',
  color: theme.colors.text.secondary,
  gap: `${theme.spacing[12]}px`,
  textAlign: 'center',
});

export const InlineVerificationActions = styled(Stack, {
  shouldForwardProp: (prop) => prop !== '$pageLayout',
})<{ $pageLayout: boolean }>(({ $pageLayout }) => ({
  alignItems: 'center',
  flexDirection: 'row',
  gap: `${theme.spacing[8]}px`,
  justifyContent: 'flex-end',
  marginTop: 0,

  '& > button': {
    width: theme.spacing[128],
  },

  ...($pageLayout && {
    width: '100%',

    '& > button': {
      flexGrow: 1,
      minHeight: `${theme.spacing[48]}px`,
    },
  }),

  [forMobile]: {
    alignItems: 'stretch',
    flexDirection: 'column',
    width: '100%',

    '& > button': {
      width: '100%',
      minHeight: theme.spacing[48],
    },
  },
}));
